/* import __COLOCATED_TEMPLATE__ from './video-editor.hbs.js'; */
import Component from '@glimmer/component';
import { generateVideoUrl } from '@intercom/composer-core';
export default class VideoEditor extends Component {
  get composer() {
    return this.args.composer;
  }
  get node() {
    let selection = this.composer.state.prosemirrorState.selection;
    return selection?.node;
  }
  get isVisible() {
    return this.composer.state.prosemirrorState.schema.nodes.video && this.node?.type === this.composer.state.prosemirrorState.schema.nodes.video;
  }
  get url() {
    let {
      provider,
      id
    } = this.node?.attrs;
    return generateVideoUrl(provider, id);
  }
}